import { Component, inject, viewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LeafletModule } from '@bluehalo/ngx-leaflet';
import { latLng, LeafletMouseEvent, Map, marker, Marker, tileLayer } from 'leaflet';
import { Subject } from 'rxjs';

@Component({
  selector: 'bb-map',
  imports: [LeafletModule],
  templateUrl: './map.component.html',
  styleUrl: './map.component.scss'
})
export class MapComponent {

  #route = inject(ActivatedRoute)

  mapLayers: Marker[] = [];

  latParam = parseFloat(this.#route.snapshot.paramMap.get('lat')) || 65.079966;
  lngParam = parseFloat(this.#route.snapshot.paramMap.get('long')) || -18.926909;
  zoomParam = parseFloat(this.#route.snapshot.paramMap.get('zoom')) || 7;

  options = {
    layers: [
          tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
        maxZoom: 18,
        attribution: 'Map tiles by <a href="http://stamen.com">Stamen Design</a>, under <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>. Data by <a href="http://openstreetmap.org">OpenStreetMap</a>, under <a href="http://www.openstreetmap.org/copyright">ODbL</a>.'
      }),
    ],
    zoom: this.zoomParam,
    center: latLng(this.latParam, this.lngParam)
  };

  onClickMap(it: LeafletMouseEvent){
    const m = marker([it.latlng.lat, it.latlng.lng], {opacity: 10});
    this.mapLayers.push(m);
    this.goTo(it.latlng.lat, it.latlng.lng);
  }

  mapInstance?: Map;
  mapReady(map: Map){
    this.mapInstance = map;
    console.log('Map is ready:', map);
  }

  goTo(lat: number, lng: number, zoom: number = 13) {
    this.mapInstance?.flyTo([lat, lng], zoom);
  }

  gotoCurrentLocation(){
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;
        this.goTo(lat, lng, 14);
      });
    }
  }
}
